/**
 * Document / Ant Design direction follows the URL locale, not i18n.dir().
 * i18next is Hebrew-only (supportedLngs: ["he"]); /en and /el still need LTR layout.
 */

let currentDir =
  typeof window !== "undefined" && /^\/(en|el)(\/|$)/.test(window.location.pathname)
    ? "ltr"
    : "rtl";

const listeners = new Set();

export function getUiDirection() {
  return currentDir;
}

export function resolveUiDirectionFromLocale(locale) {
  return locale === "he" ? "rtl" : "ltr";
}

export function setUiDirection(next) {
  const dir = next === "ltr" ? "ltr" : "rtl";
  currentDir = dir;
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.body?.setAttribute("dir", dir);
  }
  listeners.forEach((fn) => fn(dir));
}

export function subscribeUiDirection(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
